// src/wc-marquee.js
var WCMarquee = class extends HTMLElement {
  static get observedAttributes() {
    return ["party"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.__initialized) {
      return;
    }
    if (oldValue !== newValue) {
      this[name] = newValue;
    }
  }
  constructor() {
    super();
    const template = document.createElement("template");
    template.innerHTML = WCMarquee.template();
    this.attachShadow({mode: "open"});
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    this.__element = this.shadowRoot.querySelector(".marquee");
    this.__initialized = false;
  }
  async connectedCallback() {
    this.style.width = this.style.width ? this.style.width : "100%";
    this.__initialized = true;
  }
  disconnectedCallback() {
  }
  
  static template() {
    return `
      <style>
      .marquee {
        margin: 0 auto;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
            position: absolute;
    top: 0;
      }
      
      .marquee span {
        display: inline-block;
        animation: marquee 5s linear infinite;
            line-height: 1;
    padding-top: 0.7px;
      }
      
      @keyframes marquee {
        0% {
          transform: translate(0, 0);
        }
        100% {
          transform: translate(calc(-50% - 7.5px), 0);
        }
      }
      </style>
      <p class="marquee" style="width: inherit;"><span><slot></slot></span></p>`;
  }
};
customElements.define("wc-marquee", WCMarquee);